var Backbone = require('backbone');
var Payout = Backbone.Model.extend({
    idAttribute: "_id"
});
export default Payout;
